"use client";

import { useState } from "react";
import Button from "@/src/components/ui/Button";
import CustomSelect from "@/src/components/ui/CustomSelect";
import { GraduationCap, University, Search } from "lucide-react";
import { useTranslations } from "next-intl";
import { UniversityType } from "@/src/lib/universities";
import { SpecializationType } from "@/src/lib/programs";
import { useRouter } from "@/src/navigation";

type HeroSearchBlockProps = {
  universities: UniversityType[];
  specializations: SpecializationType[];
};

const HeroSearchBlock = ({
  universities,
  specializations,
}: HeroSearchBlockProps) => {
  const [major, setMajor] = useState("");
  const [university, setUniversity] = useState("");

  const router = useRouter();

  const t = useTranslations("Hero.HeroSearchBlock");
  const tButtons = useTranslations("Buttons");

  function handleSearchClick() {
    if (major && university) router.push(`/programs/${major}`);

    if (major && !university) router.push(`/programs/${major}`);

    if (!major && university) router.push(`/universities/${university}`);
  }

  return (
    <div className="flex-col w-full md:flex-row md:w-fit bg-white px-8 py-4 flex rounded-lg md:items-center shadow-sm gap-4">
      <div className="flex flex-col items-start gap-1 pb-3 md:pb-0 border-b md:border-b-0 border-gray-200 min-w-fit">
        <span className="button1-text text-primary">{t("majorLabel")}</span>
        <CustomSelect
          id="major"
          options={specializations?.map((s) => ({
            value: s.name,
            label: s.name,
          }))}
          placeholder={t("majorPlaceholder")}
          value={major}
          onChange={setMajor}
          icon={GraduationCap}
          openArrow
          dropdownClassName="min-w-[160px]"
          followDir
        />
      </div>
      <div className="flex flex-col items-start gap-1 pb-3 md:pb-0 border-b md:border-b-0 border-gray-200 min-w-fit">
        <span className="button1-text text-primary">
          {t("universityLabel")}
        </span>
        <CustomSelect
          id="university"
          options={universities?.map((u) => ({
            value: u.university,
            label: u.university,
          }))}
          placeholder={t("universityPlaceholder")}
          value={university}
          onChange={setUniversity}
          icon={University}
          openArrow
          dropdownClassName="min-w-[160px]"
          followDir
        />
      </div>
      <div>
        <Button
          onClick={handleSearchClick}
          className="flex gap-2 items-center justify-center w-full md:w-auto"
        >
          {tButtons("search")}
          <Search />
        </Button>
      </div>
    </div>
  );
};

export default HeroSearchBlock;
